import {create} from "zustand";
import {persist} from 'zustand/middleware';


export const useAuthStore = create(
    persist(
        (set) => ({
            authorized: false,
            userInfo: {},
            setUserInfo: (userInfo) => {
                set({
                    userInfo: userInfo,
                });
            },
            setAuthorized: (payload) => {
                set({authorized: payload});
            }}
         ), {
            name: 'auth',
            version: '1.0'
        })
);